"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
const namesData = [{
  name: "Alexander",
  meaning: "Defender of the people",
  letter: "A"
}, {
  name: "Asher",
  meaning: "Happy, blessed",
  letter: "A"
}, {
  name: "Arthur",
  meaning: "Bear",
  letter: "A"
}, {
  name: "August",
  meaning: "Great, magnificent",
  letter: "A"
}, {
  name: "Benjamin",
  meaning: "Son of the right hand",
  letter: "B"
}, {
  name: "Brooks",
  meaning: "Of the brook",
  letter: "B"
}, {
  name: "Bennett",
  meaning: "Blessed",
  letter: "B"
}, {
  name: "Beau",
  meaning: "Handsome",
  letter: "B"
}, {
  name: "Caleb",
  meaning: "Devotion to God",
  letter: "C"
}, {
  name: "Carter",
  meaning: "Cart driver",
  letter: "C"
}, {
  name: "Charles",
  meaning: "Free man",
  letter: "C"
}, {
  name: "Cole",
  meaning: "Swarthy, coal black",
  letter: "C"
}, {
  name: "Daniel",
  meaning: "God is my judge",
  letter: "D"
}, {
  name: "Declan",
  meaning: "Man of prayer",
  letter: "D"
}, {
  name: "Dawson",
  meaning: "Son of David",
  letter: "D"
}, {
  name: "Dean",
  meaning: "Valley",
  letter: "D"
}, {
  name: "Ethan",
  meaning: "Strong, firm",
  letter: "E"
}, {
  name: "Ezra",
  meaning: "Help",
  letter: "E"
}, {
  name: "Elias",
  meaning: "Yahweh is God",
  letter: "E"
}, {
  name: "Emmett",
  meaning: "Universal",
  letter: "E"
}, {
  name: "Felix",
  meaning: "Happy, fortunate",
  letter: "F"
}, {
  name: "Finn",
  meaning: "Fair or white",
  letter: "F"
}, {
  name: "Fletcher",
  meaning: "Arrow-maker",
  letter: "F"
}, {
  name: "Ford",
  meaning: "River crossing",
  letter: "F"
}, {
  name: "Gabriel",
  meaning: "God is my strength",
  letter: "G"
}, {
  name: "Gideon",
  meaning: "Great destroyer",
  letter: "G"
}, {
  name: "Graham",
  meaning: "Gravelly homestead",
  letter: "G"
}, {
  name: "Grant",
  meaning: "Large",
  letter: "G"
}, {
  name: "Henry",
  meaning: "Estate ruler",
  letter: "H"
}, {
  name: "Hudson",
  meaning: "Son of Hugh",
  letter: "H"
}, {
  name: "Harrison",
  meaning: "Son of Harry",
  letter: "H"
}, {
  name: "Hayes",
  meaning: "Hedged area",
  letter: "H"
}, {
  name: "Isaac",
  meaning: "He will laugh",
  letter: "I"
}, {
  name: "Isaiah",
  meaning: "Salvation of the Lord",
  letter: "I"
}, {
  name: "Ian",
  meaning: "The Lord is gracious",
  letter: "I"
}, {
  name: "Idris",
  meaning: "Studious",
  letter: "I"
}, {
  name: "James",
  meaning: "Supplanter",
  letter: "J"
}, {
  name: "Julian",
  meaning: "Youthful",
  letter: "J"
}, {
  name: "Jack",
  meaning: "God is gracious",
  letter: "J"
}, {
  name: "Jude",
  meaning: "Praised",
  letter: "J"
}, {
  name: "Kai",
  meaning: "Sea",
  letter: "K"
}, {
  name: "Knox",
  meaning: "Round hill",
  letter: "K"
}, {
  name: "Kieran",
  meaning: "Little dark one",
  letter: "K"
}, {
  name: "Killian",
  meaning: "Church",
  letter: "K"
}, {
  name: "Liam",
  meaning: "Strong-willed warrior",
  letter: "L"
}, {
  name: "Lucas",
  meaning: "Bringer of light",
  letter: "L"
}, {
  name: "Leo",
  meaning: "Lion",
  letter: "L"
}, {
  name: "Levi",
  meaning: "Joined, attached",
  letter: "L"
}, {
  name: "Mason",
  meaning: "Worker in stone",
  letter: "M"
}, {
  name: "Miles",
  meaning: "Soldier or merciful",
  letter: "M"
}, {
  name: "Micah",
  meaning: "Who is like God?",
  letter: "M"
}, {
  name: "Maxwell",
  meaning: "Great stream",
  letter: "M"
}, {
  name: "Noah",
  meaning: "Rest, wandering",
  letter: "N"
}, {
  name: "Nolan",
  meaning: "Champion",
  letter: "N"
}, {
  name: "Nathaniel",
  meaning: "Gift of God",
  letter: "N"
}, {
  name: "Nash",
  meaning: "By the ash tree",
  letter: "N"
}, {
  name: "Oliver",
  meaning: "Olive tree",
  letter: "O"
}, {
  name: "Owen",
  meaning: "Young warrior",
  letter: "O"
}, {
  name: "Orion",
  meaning: "Rising star",
  letter: "O"
}, {
  name: "Oscar",
  meaning: "God spear",
  letter: "O"
}, {
  name: "Parker",
  meaning: "Park keeper",
  letter: "P"
}, {
  name: "Preston",
  meaning: "Priest's estate",
  letter: "P"
}, {
  name: "Peter",
  meaning: "Rock",
  letter: "P"
}, {
  name: "Patrick",
  meaning: "Noble, patrician",
  letter: "P"
}, {
  name: "Quinn",
  meaning: "Descendant of Conn",
  letter: "Q"
}, {
  name: "Quincy",
  meaning: "Estate of the fifth son",
  letter: "Q"
}, {
  name: "Quentin",
  meaning: "Fifth",
  letter: "Q"
}, {
  name: "Quill",
  meaning: "Feather",
  letter: "Q"
}, {
  name: "Roman",
  meaning: "Citizen of Rome",
  letter: "R"
}, {
  name: "Rowan",
  meaning: "Little redhead",
  letter: "R"
}, {
  name: "Rhett",
  meaning: "Advice",
  letter: "R"
}, {
  name: "Reid",
  meaning: "Red-haired",
  letter: "R"
}, {
  name: "Samuel",
  meaning: "Told by God",
  letter: "S"
}, {
  name: "Silas",
  meaning: "Wood, forest",
  letter: "S"
}, {
  name: "Sebastian",
  meaning: "Venerable",
  letter: "S"
}, {
  name: "Sawyer",
  meaning: "Woodcutter",
  letter: "S"
}, {
  name: "Theodore",
  meaning: "Gift of God",
  letter: "T"
}, {
  name: "Thomas",
  meaning: "Twin",
  letter: "T"
}, {
  name: "Tristan",
  meaning: "Sorrowful",
  letter: "T"
}, {
  name: "Tobias",
  meaning: "God is good",
  letter: "T"
}, {
  name: "Uriah",
  meaning: "God is my light",
  letter: "U"
}, {
  name: "Uriel",
  meaning: "God is my light",
  letter: "U"
}, {
  name: "Ulysses",
  meaning: "Wrathful",
  letter: "U"
}, {
  name: "Umar",
  meaning: "Flourishing",
  letter: "U"
}, {
  name: "Victor",
  meaning: "Conqueror",
  letter: "V"
}, {
  name: "Vincent",
  meaning: "Conquering",
  letter: "V"
}, {
  name: "Vance",
  meaning: "Marshland",
  letter: "V"
}, {
  name: "Vaughn",
  meaning: "Small",
  letter: "V"
}, {
  name: "William",
  meaning: "Resolute protector",
  letter: "W"
}, {
  name: "Wyatt",
  meaning: "Brave in war",
  letter: "W"
}, {
  name: "Weston",
  meaning: "From the western town",
  letter: "W"
}, {
  name: "Wesley",
  meaning: "Western meadow",
  letter: "W"
}, {
  name: "Xavier",
  meaning: "New house",
  letter: "X"
}, {
  name: "Xander",
  meaning: "Defender of the people",
  letter: "X"
}, {
  name: "Xerxes",
  meaning: "Hero among rulers",
  letter: "X"
}, {
  name: "Xavi",
  meaning: "Bright",
  letter: "X"
}, {
  name: "Yusuf",
  meaning: "God increases",
  letter: "Y"
}, {
  name: "Yosef",
  meaning: "God will add",
  letter: "Y"
}, {
  name: "Yardley",
  meaning: "Wood clearing",
  letter: "Y"
}, {
  name: "York",
  meaning: "Yew estate",
  letter: "Y"
}, {
  name: "Zachary",
  meaning: "The Lord has remembered",
  letter: "Z"
}, {
  name: "Zane",
  meaning: "God is gracious",
  letter: "Z"
}, {
  name: "Zion",
  meaning: "Highest point",
  letter: "Z"
}, {
  name: "Zeke",
  meaning: "God strengthens",
  letter: "Z"
}];
const alphabet = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
export default function BoyNameDirectory() {
  return <section id="boy-name-directory" className="bg-background py-16 px-4 md:px-8 font-sans min-h-screen">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-4 gap-12">
        
        {}
        <div className="lg:col-span-3">
          <div className="mb-16">
            <h1 className="text-4xl md:text-5xl font-bold text-[var(--chart-1)] mb-6 tracking-tight">
              Boy Name Directory
            </h1>
            <p className="text-lg text-foreground max-w-2xl leading-relaxed">
              An intensive alphabetical directory of popular and classic names for boys. 
              Browse through our curated collection and hover over any name to discover its beautiful meaning and origin.
            </p>
          </div>

          <div className="space-y-24">
            {alphabet.map((letter, letterIndex) => {
            const namesForLetter = namesData.filter(n => n.letter === letter);
            if (namesForLetter.length === 0) return null;
            return <div key={letter} data-index={letterIndex} id={`letter-${letter}`} className="scroll-mt-32">
                  <h2 className="text-7xl md:text-9xl font-bold text-[var(--chart-1)] mb-10 border-b-2 border-border/40 pb-4 tracking-tighter opacity-90">
                    {letter}
                  </h2>
                  
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-4">
                    {namesForLetter.map((name, nameIndex) => <div key={name.name} data-index={nameIndex}>
                        <TooltipProvider delayDuration={200}>
                          <Tooltip>
                            <TooltipTrigger asChild>
                              <div className="px-4 py-3 text-lg text-foreground hover:bg-accent hover:text-foreground transition-all duration-300 cursor-default rounded-sm border border-transparent hover:border-accent-foreground/10 hover:shadow-sm">
                                {name.name}
                              </div>
                            </TooltipTrigger>
                            <TooltipContent side="top" className="bg-[var(--chart-1)] text-primary-foreground border-none shadow-md px-4 py-2">
                              <p className="font-medium text-sm tracking-wide">{name.meaning}</p>
                            </TooltipContent>
                          </Tooltip>
                        </TooltipProvider>
                      </div>)}
                  </div>
                </div>;
          })}
          </div>
        </div>

        {}
        <div className="hidden lg:block lg:col-span-1">
          <div className="sticky top-32 bg-card p-8 shadow-sm border border-border/30 rounded-sm">
            <h3 className="text-lg font-bold text-[var(--chart-1)] mb-6 uppercase tracking-widest border-b border-border/40 pb-3">
              Quick Jump
            </h3>
            <div className="grid grid-cols-4 gap-3">
              {alphabet.map((letter, index) => <div key={letter} data-index={index}>
                  <Link to={`#letter-${letter}`} className="flex items-center justify-center w-full aspect-square bg-background text-foreground hover:bg-accent hover:text-foreground transition-colors duration-200 text-base font-semibold shadow-xs border border-border/20 rounded-sm" aria-label={`Jump to letter ${letter}`}>
                    {letter}
                  </Link>
                </div>)}
            </div>
          </div>
        </div>

      </div>
    </section>;
}